import authInstance from "../utilities/axios/authInstance";

export const allSites = () => authInstance.get('sites');

export const oneSite = (id) => authInstance.get('sites/' + id);

export const addSite = (site) => authInstance.post('sites', site);

export const updateSite = (id, site) => authInstance.put('sites/' + id, site);

export const removeSite = (id) => authInstance.delete('sites/' + id);

export const searchSites = (site) => authInstance.get('search/sites', {
    params: {
        name: site
    }
});
